export default {
    "breakyourxxx": [
        'Zc05le75CfI', // FACT
        'F1_OQXNF8b8', // AKUMA
        'TfOx00AOfKo', // ライメイ
        'D6AmCNdwT7E', // born to be real
        'V30BhRAUCD0', // タイダナワンダー
        'llLjylG44DQ', // Present Day
        'cY8gQ7LtbKI', // Whose thorns?
        'jFcbWQufTIw', // ミッドナイト・ランナウェイ
        '1A-UuoGQaOM', // Purple Disease
        'vKSRL1THYeM', // Cry Out
        'uNQIltgLlgo', // マイロア
        'G3J06ircgMA', // ANEMONE
        'VaXpo1S21oY', // 二人三脚 feat. 猫汰つな
        '2EFxaXWinJc', // Antares
        'U8Pl7dXU280', // Twilight
        'ScTHsLH_0js', // サンビタリア
        'Ud73fm4Uoq0', // Palette
        'Srx6Qs0So_Q', // 魁
    ],
    "shinier": [
        '3UV8OZj2olg', // -ERROR
        'U8Pl7dXU280', // Twilight
        'Ud73fm4Uoq0', // Palette
        'c2hP0qWGgaA', // 凛
        'F1_OQXNF8b8', // AKUMA
        'uxjcPq0Y_IA', // バズビバザヴ
        'PMgjFPqXZV4', // My Abyss
        '1A-UuoGQaOM', // Purple Disease
        '2zTR_E0MMXg', // 心の在処はすぐ傍に
        'q9cnZ9Uz_fw', // 処方箋
        'l5I-Gg9AkSE', // 命の洗濯
        'darS1jexgTw', // TRUTH
        'tLRMiqM5TXE', // S.T.Y.
        'din8MpMohyg', // ChewyChewy feat.nqrse
        'Ig7_D9uPH10', // Present Day
        'eUmwR0x55JU', // シルベ
        '5kSJOT5hOVo', // New Order
        'TfOx00AOfKo', // ライメイ
        '3pUNgLPyjPM', // 不可視
    ]
}